<template>
  <div class="tree-wrap">
    <div class="project-selector-top">
      <el-button size="mini" @click="getDataObj">刷新</el-button>
      <el-button size="mini" @click="houseSort">排序</el-button>
      <el-dropdown size="mini" @command="handleCommand" trigger="click">
        <el-button size="mini">战区<i class="el-icon-arrow-down el-icon--right"></i></el-button>
        <el-dropdown-menu slot="dropdown" style="height: 500px; overflow-y: scroll;">
          <el-dropdown-item
            v-for="item in zoneList"
            :key="item.id"
            :command="item.id"
            >
            {{ item.name }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="project-selector">
       <el-select
         size="mini"
         style="width: 100%"
         v-model="jurisdictionId"
         filterable
         remote
         reserve-keyword
         clearable
         placeholder="请输入项目名称搜索"
         :remote-method="remoteMethod"
         :loading="loading"
         class="kuan"
         @clear="getProjectList">
         <el-option
           v-for="item in jurisdictionList"
           :key="item.id"
           :label="item.name"
           :value="item.id">
         </el-option>
       </el-select>
    </div>
    <div class="el-tree-1" :style="{height: height}">
      <CustomTree
        ref="tree"
        :data="data"
        :empty-text="emptyText"
        :props="defaultProps"
        :lazy="true"
        :load="getData"
        @node-click="nodeClick"
        node-key="id"
        children="children"
        @node-expand="nodeExpand"
        @node-collapse="nodeCollapse"
      >
        <div slot-scope="{ node }" :title="node.data.customerName||node.data.name">
          <span v-if="node.data.type==='room'" class="fangtai" :class="roomStatusIoc(node.data.room_status_ids)"></span>
          <span class="fangtai-name">{{ node.label }}</span>
      </div>
      </CustomTree>
    </div>

<!--    <ErpTreeUpdateStatus ref="ErpTreeUpdateStatus" />-->
  </div>
</template>

<script>
import CustomTree from "./tree/src/CustomTree";
import ERP from "../../../assets/lib/ERP";

export default {
    name: 'erp-tree-status',
    components: {CustomTree},
    props: {
      api: {
        type: String,
        default() {
          return ""
        }
      },
      height:{
        type:String,
        default() {
            return "calc( 100vh - 220px )";
        }
      }
    },
    data() {
      return {
        jurisdictionId: '',
        jurisdictionList: [],
        projectId: 0,
        building: '',
        unit: '',
        data: [],
        emptyText: '没有数据',
        defaultProps: {
          label: 'name',
          isLeaf: 'leaf',
        },
        loading: false,
        zoneList: [],
        zoneId: ""
      }
    },
    created() {
      // this.getJurisdiction()
      // this.getProjectList()

    },
    mounted() {
      const that=this;
      if(that.__HOUSE_TREE__.length>0){
        that.data=ERP.reJson(that.__HOUSE_TREE__);
        that.$nextTick(function () {
          that.$refs.tree.setDefaultExpandedKeys(that.__HOUSE_TREE_OPEN__)
        })
      }else {
        this.getProjectList()
      }
      this.getJurisdiction(),
      this.getZoneList()
    },
    activated() {
      const that=this;
      if(that.__HOUSE_TREE__.length>0){
        that.data=ERP.reJson(that.__HOUSE_TREE__);
        that.$nextTick(function () {
          that.$refs.tree.setDefaultExpandedKeys(that.__HOUSE_TREE_OPEN__)
        })
      }else {
        this.getProjectList()
      }
    },
    watch: {
      jurisdictionId(val) {
        this.getProjectList()
      },
      __HOUSE_TREE__:{
        deep:true,
        immediate:true,
        handler(o,n){
          const that=this;
          // if(JSON.stringify(that.__HOUSE_TREE__)!==JSON.stringify(that.data)){
          //   that.data=ERP.reJson(that.__HOUSE_TREE__)
          //   that.$nextTick(function () {
          //     let expandNodes=that.$refs.tree.getExpandNodes().map(ret=>ret.id);
          //     that.$refs.tree.setDefaultExpandedKeys(expandNodes)
          //   })
          // }

        }
      },
      zoneId(n) {
        this.getProjectList()
      }
    },
    computed:{
      __HOUSE_TREE__(){
        return ERP.getStore().__HOUSE_TREE__
      },
      __HOUSE_TREE_LIST__(){
        return ERP.getStore().__HOUSE_TREE_LIST__
      },
      __HOUSE_TREE_OPEN__(){
        return ERP.getStore().__HOUSE_TREE_OPEN__
      },
    },
    methods: {
      houseSort(){
        ERP.navigateTo("/Config/ErpTreeUpdateStatus")
      },
      getDataObj(){
        this.data=[];
        this.jurisdictionId= '';
        this.jurisdictionList= [];
        this.projectId=0;
        this.building=''
        this.unit=''
        this.zoneId = ""
        this.defaultProps= {
          label: 'name',
          isLeaf: 'leaf',
        }
        ERP.setStore('__HOUSE_TREE_OPEN__',[])
        this.getJurisdiction()
        this.getProjectList()
      },
      // 获得自己和自己名下的架构
      getJurisdiction() {
        this.$myhttp.get('admin/common/jurisdiction',{
        'Content-Type': 'application/json'
        }).then(backdata=>{
        	if(backdata.data.code == 200) {
        	  this.jurisdictionList = backdata.data.data
        	} else {
            this.$message.error(backdata.data.message);
        	}
        });
      },
      // 获取自己名下的战区
      getZoneList() {
        this.$myhttp.post('admin/common/zones', {},{
          'Content-Type': 'application/json'
        }).then((backdata)=>{
          if(backdata.data.code == 200) {
            this.zoneList = backdata.data.data
          }
        });
      },

      // 获得自己名下的所有项目
      getProjectList() {
        const that=this;
        that.$myhttp.get('admin/common/pindex?projectId=' + this.jurisdictionId + "&zoneId=" + this.zoneId,{
          'Content-Type': 'application/json'
        }).then(backdata=>{
        	if(backdata.data.code == 200) {
            that.jurisdictionList = backdata.data.data;
            that.data = backdata.data.data.map((item) => {
              //return {id: item.id, name: item.name, type: 'project'}
              return {
                'name':item.name,
                'id':item.id,
                'region':0,
                'type':'project',
                'pindex_id':item.id,
                superior:'0',
                'projectId':item.id,
                dataObj:item
              }
            })
            that.$nextTick(()=>{
              that.onHouseTree()
            })
          } else {
            this.$message.error(backdata.data.message);
          }
        });
      },

      // 根据架构获得项目(废弃)
      getProjectListByJurisdiction(jurisdictionId) {
        const that=this;
        this.$myhttp.get(`admin/common/jurisdictionPindex?jurisdiction_id=${jurisdictionId}`,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
        	if(backdata.data.code == 200) {
        	  this.data = backdata.data.data.map((item) => {
              //return {id: item.id, projectId: item.id, name: item.name, type: 'project'}
              return {'name':item.name,'id':item.id,'region':0,'type':'project','pindex_id':item.id,superior:'0','projectId':item.id,dataObj:item}
            })
            that.$nextTick(()=>{
              that.onHouseTree()
            })
        	} else {
            this.$message.error(backdata.data.message);
        	}
        });
      },

      getData(node, resolve) {
        const that=this;
        const region_id = node.data.id;
        const _this = this;

        if(region_id == '' || region_id == undefined){
          return false;
        }

        if(node.childNodes&&node.childNodes.length){
          if(node.data){
            let node_data=getNodes(node)
            setTimeout(() => {
              resolve(node_data.children);
            },100)
            return false
          }
        }else {
          let tree_list=that.__HOUSE_TREE_LIST__.filter(ret=>{
            if(node.data.type==='project'){
              return ret.level==2&&ret.pindex_id==node.data.id
            }else {
              return ret.parent_id==node.data.id
            }
          });
          if(tree_list.length>0){
            setTimeout(() => {
              resolve(tree_list);
            },100)
            return false
          }else {
            setTimeout(() => {
              //加载
              node.data.region_id = region_id;
              node.data && this.$myhttp.post('admin/common/getbindingArrs',node.data,{
                'Content-Type': 'application/json'
              }).then(backdata=>{ // 异步执行成功后
                // _this.defaultcheckedkeys =  _this.arr;
                resolve(backdata.data);
                that.$nextTick(function () {
                  that.onHouseTree()
                })
                return false
              });
            }, 200);
          }
        }
      },
      nodeClick(data, node) {
        var d = {
          level: node.level,
          type: node.data.type,
          id: node.data.id,
          name: node.data.name,
          superior: node.data.superior,
          tree:nodeToList(node),
          customerName:
            typeof node.data.customerName == "string"
              ? node.data.customerName
              : "",
        }
        this.$emit('node-click', d)
      },
      roomStatusIoc(ids){
        // 1	空置	空	1	1	开发商未出售的房子
        // 2	未领	锁	2	1	已售、未交楼（出售、入伙）
        // 3	空关	关	4	1	已售、已交楼、未装修、未入住
        // 4	装修	装	8	1	在装修
        // 5	入住	绿人	16	1	已入住
        // 6	出租	租	32	1	已出租
        // 7	停用		64	1
        // 8	其他		128	0
        //chuzu,kongguan,kongzhi,ruzhu,zhuangxiu,tingyong,weiling

        let icons=['kongzhi','weiling','kongguan','zhuangxiu','ruzhu','chuzu','tingyong','qita']

        try {
          ids.findIndex(',')!==-1&&(ids=ids.split(','),ids=ids[0]);
        }catch (e) {

        }

        return 'fangtai_'+icons[ids-1]
      },
      nodeExpand(data){
        const that=this;
        let ids=that.__HOUSE_TREE_OPEN__
        if(!ids.includes(data.id)){
          ids.push(data.id)
          ERP.setStore('__HOUSE_TREE_OPEN__',ids)
        }
        console.log(ids)
      },
      nodeCollapse(data){
        const that=this;
        let ids=that.__HOUSE_TREE_OPEN__
        if(ids.includes(data.id)){
          let idx=ids.indexOf(data.id)
          ids.splice(idx,1)
          ERP.setStore('__HOUSE_TREE_OPEN__',ids)
        }
        console.log(ids)
      },
      onHouseTree(){
        const that=this;
        let rootNode=that.$refs.tree.getRootNodes()
        let node_list=that.$refs.tree.getAllNodes();
        ERP.setStore('__HOUSE_TREE__',ERP.reJson(rootNode.children))
        ERP.setStore('__HOUSE_TREE_LIST__',ERP.reJson(node_list))
      },
      remoteMethod(query) {
        if (query !== "") {
          this.loading = true;
          setTimeout(() => {
            this.$myhttp
              .post(
                "admin/common/searchProject",
                { keyword: query },
                {
                  "Content-Type": "application/json",
                }
              )
              .then((backdata) => {
                if (backdata.data.code == 200) {
                  this.jurisdictionList = backdata.data.data;
                } else {
                  this.$message.error(backdata.data.message);
                }
              });
            this.loading = false;
          }, 200);
        }
      },
      handleCommand(command) {
        this.zoneId = command
      }
    }
  }

  function nodeToList(node) {
    let node_list=[]
    node_list[10]=node.data;
    let nodeObj=node
    for(let i=9;i>0;i--){
      nodeObj['parent']&&(nodeObj=nodeObj['parent'],node_list[i]=nodeObj.data[0]?nodeObj.data[0]:nodeObj.data);
    }
    return node_list.filter(ret=>{return ret}).splice(1)
  }

  function getNodes(__checkedNodes){
    const checkedNodes = {};
    const traverse = function(node,_checkedNodes={}) {
      const childNodes = node.root ? node.root.childNodes : node.childNodes;
      childNodes.forEach((child,index) => {
        !_checkedNodes.children&&(_checkedNodes.children=[])
        _checkedNodes.children[index]={
          ...child.data,
          expanded:child.expanded!==undefined?child.expanded:false,
          leaf: false,
        };
        traverse(child,_checkedNodes.children[index]);
      });
    };
    traverse(__checkedNodes,checkedNodes);
    return checkedNodes;
  }

  function noRepeat(arr){
     //利用了Set结构不能接收重复数据的特点
    return [...new Set(arr)]
  }
</script>

<style lang="scss">
  .el-tree-1{
    overflow-y: scroll;
    //height: calc( 100vh - 120px );
    width: 100%;
  }
  .tree-wrap {
    width: 250px;
  }

  .fangtai{
    width: 18px;
    height: 18px;
    margin-right: 25px;
    position: relative;
    &::before{
      content: " ";
      position: absolute;
      width: 18px;
      height: 18px;
      right: 0;
      left: 0;
      top: 0;
      bottom: 0;
      background-image: url("../../../assets/image/fangtai/chuzu.png");
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      z-index: 99;
    }
  }
  $icons:chuzu,kongguan,kongzhi,ruzhu,zhuangxiu,tingyong,weiling;
  @each $i in $icons{
    .fangtai_#{$i}{
      &::before{
        background-image: url("../../../assets/image/fangtai/#{$i}.png");
      }
    }
  }
  .fangtai-name{

  }

  .project-selector {
    margin-bottom: 10px;
  }
  .project-selector-top {
    margin-bottom: 5px;
    margin-top: 5px;
    display: flex;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/Common/erp-tree-status.vue